import { useEffect, useState } from "react";
import gallery1 from "../assets/PEN SA - Gallery Photos/0AR00129.JPG";
import gallery2 from "../assets/PEN SA - Gallery Photos/Copy of 0AR00139.JPG";
import gallery3 from "../assets/PEN SA - Gallery Photos/Copy of 0AR00260.JPG";
import gallery4 from "../assets/PEN SA - Gallery Photos/Copy of 3.JPG";
import gallery5 from "../assets/PEN SA - Gallery Photos/Copy of Akitha.JPG";
import gallery6 from "../assets/PEN SA - Gallery Photos/Copy of Ansu Elsa Joy.JPG";
import gallery7 from "../assets/PEN SA - Gallery Photos/Copy of Chandrasekar.JPG";
import gallery8 from "../assets/PEN SA - Gallery Photos/Copy of Dhanalakshmi.JPG";
import gallery9 from "../assets/PEN SA - Gallery Photos/Copy of Dhasarathi.JPG";
import gallery10 from "../assets/PEN SA - Gallery Photos/Copy of Gopika Sivan.JPG";
import gallery11 from "../assets/PEN SA - Gallery Photos/Copy of Kalidass.JPG";
import gallery12 from "../assets/PEN SA - Gallery Photos/Copy of Kanmani.JPG";
import gallery13 from "../assets/PEN SA - Gallery Photos/Copy of Lakshmi Priya.JPG";
import gallery14 from "../assets/PEN SA - Gallery Photos/Copy of Maanini Jayal.JPG";
import gallery15 from "../assets/PEN SA - Gallery Photos/Copy of Mohana Priya.JPG";
import gallery16 from "../assets/PEN SA - Gallery Photos/Copy of Nita Ann.JPG";
import gallery17 from "../assets/PEN SA - Gallery Photos/Copy of Palanisamy.JPG";
import gallery18 from "../assets/PEN SA - Gallery Photos/Copy of Pugalendhi.JPG";
import gallery19 from "../assets/PEN SA - Gallery Photos/Copy of Sadasivam.JPG";
import gallery20 from "../assets/PEN SA - Gallery Photos/Copy of Sudha.JPG";
import gallery21 from "../assets/PEN SA - Gallery Photos/Copy of Thamarai Selvan.JPG";
import gallery22 from "../assets/PEN SA - Gallery Photos/Copy of Viji M.JPG";
import "../styles/gallery.scss";

const Gallery = () => {
  const images = [
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,
    gallery9,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    gallery16,
    gallery17,
    gallery18,
    gallery19,
    gallery20,
    gallery21,
    gallery22,
  ];

  const slides = [];
  for (let i = 0; i < images.length; i += 4) {
    slides.push(images.slice(i, i + 4));
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => {
        if (prev === slides.length - 1) {
          return 0;
        } else {
          return prev + 1;
        }
      });
    }, 10000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="gallery-container">
      <h1>PEN Scholar Award Gallery</h1>
      <div className="gallery-slider-wrapper">
        <div
          className="gallery-slider"
          style={{
            transform: `translateX(-${currentIndex * 100}%)`,
            transition:
              currentIndex === 0 ? "none" : "transform 0.8s ease-in-out",
          }}
        >
          {slides.map((group, slideIdx) => (
            <div className="gallery-slide" key={slideIdx}>
              {group.map((img, idx) => (
                <img
                  src={img}
                  alt={`gallery-${slideIdx}-${idx}`}
                  key={idx}
                  className="gallery-image"
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;
